/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { DotsLine, Next, Prev } from "../../common/svg/AllSvg";
import Slider from "react-slick";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const VacancieDetailsInfo = ({ job }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const { t } = useTranslation('common');
    const arrowRef: any = useRef(null);
    const params = useParams();

    const settings = {
        dots: false,
        variableWidth: true,
        arrows: false,
        infinite: data?.length > 3 ? true : false,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    variableWidth: false,
                    infinite: data?.length > 3 ? true : false,
                }
            },
        ]

    }

    const getData = async () => {
        try {
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.relatedJob}?job_id=${params?.jobId}`);

            if (res && res.status === 200) {
                setData(res?.data)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("error while fetching job detail", error);
        }
    }

    useEffect(() => {
        (!!params?.jobId && !!lang) && getData();
    }, [params?.jobId, lang])

    return (
        <div className="py-[30px] lg:py-[45px]  w-full h-full overflow-hidden">
            <div className="container w-full h-full flex items-center justify-center">
                <div className="w-full xl:w-[1100px] xlx:w-[1250px] px-[15px] xs:px-[20px] xl:px-[35px] flex flex-col gap-[30px] lg:gap-[40px]">
                    <div className="flex flex-col gap-[12px]">
                        <h5 className="text-primaryText dark:text-white font-bold uppercase">{t("recruitment.home.job_list.qualification")}</h5>
                        <ul className="ml-[30px]">
                            <li className="font-normal text-blackDull dark:text-textBlackDull text-sm leading-snug list-disc">{job?.qualification}
                            </li>
                        </ul>
                    </div>

                    <div className="flex flex-col gap-[12px]">
                        <h5 className="text-primaryText dark:text-white font-bold uppercase">{t("recruitment.home.job_list.man_exp")}</h5>
                        <ul className="ml-[30px] gap-[15px] lg:gap-[20px] flex flex-col">
                            <li className="font-normal text-blackDull dark:text-textBlackDull text-sm leading-snug list-disc">{job?.mandatory_experience}</li>
                        </ul>
                    </div>

                    <div className="flex flex-col gap-[12px]">
                        <h5 className="text-primaryText dark:text-white font-bold uppercase">{t("recruitment.home.job_list.desirable")}</h5>
                        <ul className="ml-[30px] gap-[15px] lg:gap-[20px] flex flex-col">
                            <li className="font-normal text-blackDull dark:text-textBlackDull text-sm leading-snug list-disc">{job?.desirable_experience}</li>
                        </ul>
                    </div>

                    {(data?.length > 0 && !loading) && <>
                        <div className="w-full overflow-hidden">
                            <DotsLine />
                        </div>

                        <div className="flex flex-col gap-[15px] lg:gap-[20px] w-full">
                            <h5 className="text-primaryText dark:text-white font-bold uppercase">{t("recruitment.home.job_list.related_jobs")}</h5>

                            <Slider className='h-full flex w-[100vw]' ref={arrowRef} {...settings}>
                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                    <div className="pr-[10px] lg:pr-[15px] xl:pr-[20px]" key={index}>
                                        <div className="w-[355px] xsm:w-[425px] xlx:w-[470px] h-fit min-h-[128px] xlx:min-h-[140px] bg-white dark:bg-bgDarkDull border border-[#E5E5E5] dark:border-[#454545] flex py-[18px] px-[16px] gap-[15px]" >
                                            <div style={{ backgroundColor: `${item?.department_details?.bg_color}` }} className="xlx:min-w-[100px] xlx:h-[100px] min-w-[90px] h-[90px] flex items-center justify-center rounded-[8px]">
                                                <img src={item?.department_details?.icon?.aws_file_url} alt="icon" className="w-[45px]" />
                                            </div>

                                            <div className="flex flex-col gap-[5px] xlx:gap-[6px]">
                                                <h6 className="text-blackDull dark:text-textBlackDull font-medium">{item?.department_details?.name}</h6>
                                                <h4 className="text-primaryText dark:text-white font-semibold ">{item?.job_role}</h4>
                                                <div className="flex gap-[8px] xs:flex-row flex-col">
                                                    <h6 className="text-danger dark:text-darkDanger font-semibold whitespace-nowrap">{t("recruitment.home.job_list.emp")} :</h6>
                                                    <div className="flex items-center gap-[8px] flex-wrap">
                                                        {Array?.isArray(item?.employment_nature_detail) && item?.employment_nature_detail?.map((i: any, index: number) => (
                                                            <div key={index} className="bg-[#F1F1F1] dark:bg-[#d4d5d838] rounded-[20px] px-[11px] py-[0.5px] flex items-center justify-center w-fit text-blackDull dark:text-textBlackDull font-medium text-[0.813rem]">
                                                                {i?.title}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="flex gap-[4px] xs:gap-[6px] xs:flex-row flex-col">
                                                    <h6 className="text-danger dark:text-darkDanger font-semibold">{t("recruitment.home.ads_list.last_date")} : </h6>
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold">{moment(item?.advertisement_details?.last_date_submission).format('MMM DD, YYYY')}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>

                            <div className="w-full flex items-end justify-end mt-[15px] sm:mt-[25px]">
                                <div className="flex items-center gap-[8px] justify-end w-full">
                                    <button aria-label={t("aria_label.prev_arr")}
                                        title={t("aria_label.prev")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickPrev()}>
                                        <Prev className="fill-[#3D3D3D] !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                                    </button>
                                    <button aria-label={t("aria_label.next_arr")}
                                        title={t("aria_label.next")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickNext()}>
                                        <Next className="fill-[#3D3D3D] !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>}
                </div>
            </div>
        </div>
    );
};

export default VacancieDetailsInfo;